import {
  ActionElement,
  DragHandle,
  InlineCombinator,
  LogType,
  NotToggle,
  QueryBuilderContext,
  QueryBuilderInternal,
  QueryBuilderStateContext,
  Rule,
  RuleComponents,
  RuleGroup,
  RuleGroupBodyComponents,
  RuleGroupHeaderComponents,
  ShiftActions,
  TestID,
  ValueEditor,
  ValueSelector,
  add,
  celCombinatorMap,
  convertFromIC,
  convertQuery,
  convertToIC,
  defaultCELValueProcessor,
  defaultCombinators,
  defaultCombinatorsExtended,
  defaultControlClassnames,
  defaultControlElements,
  defaultExportOperatorMap,
  defaultJoinChar,
  defaultMongoDBValueProcessor,
  defaultNLTranslations,
  defaultOperatorNegationMap,
  defaultOperatorProcessorNL,
  defaultOperatorProcessorSQL,
  defaultOperators,
  defaultPlaceholderFieldGroupLabel,
  defaultPlaceholderFieldLabel,
  defaultPlaceholderFieldName,
  defaultPlaceholderLabel,
  defaultPlaceholderName,
  defaultPlaceholderOperatorGroupLabel,
  defaultPlaceholderOperatorLabel,
  defaultPlaceholderOperatorName,
  defaultPlaceholderValueGroupLabel,
  defaultPlaceholderValueLabel,
  defaultPlaceholderValueName,
  defaultRuleGroupProcessorCEL,
  defaultRuleGroupProcessorDrizzle,
  defaultRuleGroupProcessorElasticSearch,
  defaultRuleGroupProcessorJSONata,
  defaultRuleGroupProcessorJsonLogic,
  defaultRuleGroupProcessorLDAP,
  defaultRuleGroupProcessorMongoDB,
  defaultRuleGroupProcessorMongoDBQuery,
  defaultRuleGroupProcessorNL,
  defaultRuleGroupProcessorParameterized,
  defaultRuleGroupProcessorPrisma,
  defaultRuleGroupProcessorSQL,
  defaultRuleGroupProcessorSequelize,
  defaultRuleGroupProcessorSpEL,
  defaultRuleProcessorCEL,
  defaultRuleProcessorDrizzle,
  defaultRuleProcessorElasticSearch,
  defaultRuleProcessorJSONata,
  defaultRuleProcessorJsonLogic,
  defaultRuleProcessorLDAP,
  defaultRuleProcessorMongoDB,
  defaultRuleProcessorMongoDBQuery,
  defaultRuleProcessorNL,
  defaultRuleProcessorParameterized,
  defaultRuleProcessorPrisma,
  defaultRuleProcessorSQL,
  defaultRuleProcessorSequelize,
  defaultRuleProcessorSpEL,
  defaultSpELValueProcessor,
  defaultTranslations,
  defaultValidator,
  defaultValueProcessor,
  defaultValueProcessorByRule,
  defaultValueProcessorCELByRule,
  defaultValueProcessorMongoDBByRule,
  defaultValueProcessorNL,
  defaultValueProcessorSpELByRule,
  filterFieldsByComparator,
  findID,
  findPath,
  formatQuery,
  generateAccessibleDescription,
  generateID,
  getCommonAncestorPath,
  getCompatContextProvider,
  getFirstOption,
  getNLTranslataion,
  getOption,
  getParentPath,
  getParseNumberMethod,
  getPathOfID,
  getQuerySelectorById,
  getQuoteFieldNamesWithArray,
  getQuotedFieldName,
  getValidationClassNames,
  getValueSourcesUtil,
  group,
  groupInvalidReasons,
  insert,
  isAncestor,
  isFlexibleOptionArray,
  isFlexibleOptionGroupArray,
  isFullOptionArray,
  isFullOptionGroupArray,
  isOptionGroupArray,
  isPojo,
  isRuleGroup,
  isRuleGroupType,
  isRuleGroupTypeIC,
  isRuleOrGroupValid,
  isValidValue,
  isValidationResult,
  isValueProcessorLegacy,
  joinWith,
  jsonLogicAdditionalOperators,
  mapSQLOperator,
  mergeClassnames,
  mergeTranslation,
  mergeTranslations,
  messages,
  mongoDbFallback,
  mongoOperators,
  move,
  normalizeConstituentWordOrder,
  nullFreeArray,
  nullOrUndefinedOrEmpty,
  numericRegex,
  numerifyValues,
  objectEntries,
  objectKeys,
  parseNumber,
  pathIsDisabled,
  pathsAreEqual,
  preferProp,
  prepareRule,
  prepareRuleGroup,
  prepareRuleOrGroup,
  prismaFallback,
  prismaOperators,
  regenerateID,
  regenerateIDs,
  remove,
  rootPath,
  shouldRenderAsNumber,
  splitBy,
  sqlDialectPresets,
  standardClassnames,
  storeCommon,
  toArray,
  toFlatOptionArray,
  toFullOption,
  toFullOptionList,
  toFullOptionMap,
  toOptions,
  transformQuery,
  trimIfString,
  uniqByIdentifier,
  uniqByName,
  uniqOptGroups,
  uniqOptList,
  update,
  useControlledOrUncontrolled,
  useDeprecatedProps,
  useMergedContext,
  usePreferAnyProp,
  usePreferProp,
  usePrevious,
  useQueryBuilder,
  useQueryBuilderQuery,
  useQueryBuilderSchema,
  useQueryBuilderSelector,
  useQueryBuilderSetup,
  useReactDndWarning,
  useRule,
  useRuleGroup,
  useSelectElementChangeHandler,
  useStopEventPropagation,
  useValueEditor,
  useValueSelector
} from "./chunk-PJHRBEU6.mjs";

// src/redux/store.ts
import { configureStore } from "@reduxjs/toolkit";
var queryBuilderStore = configureStore({ ...storeCommon, devTools: false });

// src/components/QueryBuilder.tsx
import { jsx as jsx2 } from "react/jsx-runtime";

// src/components/QueryBuilderStateProvider.tsx
import { jsx } from "react/jsx-runtime";
import { Provider } from "react-redux";
var QueryBuilderStateProvider = (props) => /* @__PURE__ */ jsx(Provider, { context: QueryBuilderStateContext, store: queryBuilderStore, children: props.children });

// src/components/QueryBuilder.tsx
var QueryBuilder = (props) => /* @__PURE__ */ jsx2(QueryBuilderStateProvider, { children: /* @__PURE__ */ jsx2(QueryBuilderInternal, { props }) });
export {
  ActionElement,
  DragHandle,
  InlineCombinator,
  LogType,
  NotToggle,
  QueryBuilder,
  QueryBuilderContext,
  QueryBuilderStateContext,
  QueryBuilderStateProvider,
  Rule,
  RuleComponents,
  RuleGroup,
  RuleGroupBodyComponents,
  RuleGroupHeaderComponents,
  ShiftActions,
  TestID,
  ValueEditor,
  ValueSelector,
  add,
  celCombinatorMap,
  convertFromIC,
  convertQuery,
  convertToIC,
  QueryBuilder as default,
  defaultCELValueProcessor,
  defaultCombinators,
  defaultCombinatorsExtended,
  defaultControlClassnames,
  defaultControlElements,
  defaultExportOperatorMap,
  defaultJoinChar,
  defaultMongoDBValueProcessor,
  defaultNLTranslations,
  defaultOperatorNegationMap,
  defaultOperatorProcessorNL,
  defaultOperatorProcessorSQL,
  defaultOperators,
  defaultPlaceholderFieldGroupLabel,
  defaultPlaceholderFieldLabel,
  defaultPlaceholderFieldName,
  defaultPlaceholderLabel,
  defaultPlaceholderName,
  defaultPlaceholderOperatorGroupLabel,
  defaultPlaceholderOperatorLabel,
  defaultPlaceholderOperatorName,
  defaultPlaceholderValueGroupLabel,
  defaultPlaceholderValueLabel,
  defaultPlaceholderValueName,
  defaultRuleGroupProcessorCEL,
  defaultRuleGroupProcessorDrizzle,
  defaultRuleGroupProcessorElasticSearch,
  defaultRuleGroupProcessorJSONata,
  defaultRuleGroupProcessorJsonLogic,
  defaultRuleGroupProcessorLDAP,
  defaultRuleGroupProcessorMongoDB,
  defaultRuleGroupProcessorMongoDBQuery,
  defaultRuleGroupProcessorNL,
  defaultRuleGroupProcessorParameterized,
  defaultRuleGroupProcessorPrisma,
  defaultRuleGroupProcessorSQL,
  defaultRuleGroupProcessorSequelize,
  defaultRuleGroupProcessorSpEL,
  defaultRuleProcessorCEL,
  defaultRuleProcessorDrizzle,
  defaultRuleProcessorElasticSearch,
  defaultRuleProcessorJSONata,
  defaultRuleProcessorJsonLogic,
  defaultRuleProcessorLDAP,
  defaultRuleProcessorMongoDB,
  defaultRuleProcessorMongoDBQuery,
  defaultRuleProcessorNL,
  defaultRuleProcessorParameterized,
  defaultRuleProcessorPrisma,
  defaultRuleProcessorSQL,
  defaultRuleProcessorSequelize,
  defaultRuleProcessorSpEL,
  defaultSpELValueProcessor,
  defaultTranslations,
  defaultValidator,
  defaultValueProcessor,
  defaultValueProcessorByRule,
  defaultValueProcessorCELByRule,
  defaultValueProcessorMongoDBByRule,
  defaultValueProcessorNL,
  defaultValueProcessorSpELByRule,
  filterFieldsByComparator,
  findID,
  findPath,
  formatQuery,
  generateAccessibleDescription,
  generateID,
  getCommonAncestorPath,
  getCompatContextProvider,
  getFirstOption,
  getNLTranslataion,
  getOption,
  getParentPath,
  getParseNumberMethod,
  getPathOfID,
  getQuerySelectorById,
  getQuoteFieldNamesWithArray,
  getQuotedFieldName,
  getValidationClassNames,
  getValueSourcesUtil,
  group,
  groupInvalidReasons,
  insert,
  isAncestor,
  isFlexibleOptionArray,
  isFlexibleOptionGroupArray,
  isFullOptionArray,
  isFullOptionGroupArray,
  isOptionGroupArray,
  isPojo,
  isRuleGroup,
  isRuleGroupType,
  isRuleGroupTypeIC,
  isRuleOrGroupValid,
  isValidValue,
  isValidationResult,
  isValueProcessorLegacy,
  joinWith,
  jsonLogicAdditionalOperators,
  mapSQLOperator,
  mergeClassnames,
  mergeTranslation,
  mergeTranslations,
  messages,
  mongoDbFallback,
  mongoOperators,
  move,
  normalizeConstituentWordOrder,
  nullFreeArray,
  nullOrUndefinedOrEmpty,
  numericRegex,
  numerifyValues,
  objectEntries,
  objectKeys,
  parseNumber,
  pathIsDisabled,
  pathsAreEqual,
  preferProp,
  prepareRule,
  prepareRuleGroup,
  prepareRuleOrGroup,
  prismaFallback,
  prismaOperators,
  queryBuilderStore,
  regenerateID,
  regenerateIDs,
  remove,
  rootPath,
  shouldRenderAsNumber,
  splitBy,
  sqlDialectPresets,
  standardClassnames,
  toArray,
  toFlatOptionArray,
  toFullOption,
  toFullOptionList,
  toFullOptionMap,
  toOptions,
  transformQuery,
  trimIfString,
  uniqByIdentifier,
  uniqByName,
  uniqOptGroups,
  uniqOptList,
  update,
  useControlledOrUncontrolled,
  useDeprecatedProps,
  useMergedContext,
  usePreferAnyProp,
  usePreferProp,
  usePrevious,
  useQueryBuilder,
  useQueryBuilderQuery,
  useQueryBuilderSchema,
  useQueryBuilderSelector,
  useQueryBuilderSetup,
  useReactDndWarning,
  useRule,
  useRuleGroup,
  useSelectElementChangeHandler,
  useStopEventPropagation,
  useValueEditor,
  useValueSelector
};
//# sourceMappingURL=react-querybuilder.mjs.map